import React from 'react';
import Modal from '../Modal';
import Spinner from '../Spinner';

interface BusyModalProps {
  /** Whether the busy modal is open. */
  isOpen: boolean;
}

const BusyModal = ({ isOpen }: BusyModalProps) => {
  return (
    <Modal isOpen={isOpen}>
      <div className="busy-modal">
        <Spinner />
      </div>
    </Modal>
  );
};

export default BusyModal;
